module.exports = __webpack_public_path__ + "static/media/invoice-logo-water-mark.7fabfdc2.svg";